angular.module('env.data.httpInterceptors.authInterceptor', [])

    //Insert auth token into each http request
    .factory('authInterceptor', function AuthInterceptor($injector, $q) {
        var authService;
        return {
            request: function (request) {
                if (!authService) {
                    authService = $injector.get('authService', 'AuthInterceptor'); // avoid circular dependency
                }
                request.headers = request.headers || {};
                var token = authService.getToken();
                if (token) {
                    request.headers.Authorization = token;
                }
                return request || $q.when(request);
            }
        };
    })

;